<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 19L19 1"
      stroke="#80B7FF"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M1 1L19 19"
      stroke="#80B7FF"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.iconColor },
  },
  name: "IconChoiseChat",
};
</script>
